export default {
	activate: "Activate",
	buttons: {
		create: "New Attendance Type",
		delete: "Delete",
	},
	create: "Create Attendance Type",
	createdAt: "Created at",
	deactivate: "Deactivate",
	delete: "Delete Attendance Type",
	deleteConfirmation: "Are you sure you want to delete the attendance type {label}?",
	details: {
		configuration: "Configuration",
		linkedRitualTypes: "Linked Ritual Types",
		noLinkedRitualTypes: "No linked ritual types",
	},
	edit: "Edit Attendance Type",
	empty: {
		description: "Register the attendance card types for your rituals",
		title: "No attendance types found",
	},
	filters: {
		status: {
			all: "All",
		},
	},
	form: {
		code: {
			hint: "Short card code (fullCode prefix)",
			label: "Code",
			placeholder: "E.g.: A, B, PAS, PRES",
		},
		guide: {
			hint: "Spiritual guide associated with this attendance (not required)",
			label: "Spiritual Guide (optional)",
			placeholder: "Select a guide",
		},
		hasQueue: {
			hint: "Tickets are called in order (uncheck for simple attendance/registration)",
			label: "Has Queue",
		},
		label: {
			hint: "Descriptive name of the attendance type",
			label: "Card Name",
			placeholder: "E.g.: Caboclo Pena Branca Consultation",
		},
		maxTickets: {
			hint: "Maximum number of tickets (required for Fixed mode)",
			label: "Maximum Tickets",
		},
		medium: {
			hint: "Default medium who will attend this card",
			label: "Default Medium",
		},
		numberingMode: {
			label: "Display Mode",
		},
		tracksTime: {
			hint: "Record start and end time of the attendance",
			label: "Track Time",
		},
	},
	guide: "Guide",
	hasQueue: "Has Queue",
	loading: "Loading details...",
	maxTickets: "Max. Tickets",
	medium: "Medium",
	messages: {
		activated: "Attendance type {label} activated successfully",
		createError: "Error creating attendance type",
		created: "Attendance type {label} created successfully",
		deactivated: "Attendance type {label} deactivated successfully",
		deleteError: "Error deleting attendance type",
		deleted: "Attendance type {label} deleted successfully",
		loadError: "Error loading attendance types",
		toggleError: "Error changing attendance type status",
		updateError: "Error updating attendance type",
		updated: "Attendance type {label} updated successfully",
	},
	numberingMode: "Display Mode",
	numberingModes: {
		INCREMENTAL: "On demand",
		PRE_DEFINED: "Fixed",
		incrementalDescription: "Tickets added one by one, on demand",
		preDefinedDescription: "Shows all tickets from 1 to N at once",
	},
	searchPlaceholder: "Code, name or guide...",
	stats: {
		active: "Active",
		total: "Types",
	},
	status: "Status",
	table: {
		code: "Code",
		guide: "Guide",
		label: "Name",
		linkedRitualTypes: "Links",
		medium: "Medium",
		numberingMode: "Display Mode",
		status: "Status",
	},
	title: "Attendance Types",
	tracksTime: "Tracks Time",
	updatedAt: "Updated at",
	validation: {
		codeMaxLength: "Code must have at most 4 characters",
		codeRequired: "Code is required",
		labelMaxLength: "Name must have at most 100 characters",
		labelRequired: "Name is required",
		maxTicketsMin: "Minimum quantity is 1",
		maxTicketsRequired: "Maximum quantity is required for Fixed mode",
	},
	viewDetails: "View Details",
};
